import get from 'lodash.get';
import { config } from '@yola/ws-sdk';

const getGoogleMapsEmbedApiKey = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  return get(cfg, 'common.google_maps.embed_api_key', null);
};

export default getGoogleMapsEmbedApiKey;
